export default "__VITE_ASSET__CN8x9rh5__"